import clsx from 'clsx';
import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { useAppContext } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { article_path } from '@routes';
import { ClickTarget, click } from '@tracking';
import { getArticleImgSrc } from '@utils/images';

import IconProTagThumbnail from '../Images/Rebranding/IconProTagThumbnail';

interface ArticleImageProps {
  className?: string;
  id: number;
  isMobileFullWidth?: boolean;
  isPro: boolean;
  picture: string;
  sizes?: string;
  slug: string;
  title: string;
}

const ArticleImage = ({
  className,
  id,
  isMobileFullWidth,
  isPro,
  picture,
  sizes,
  slug,
  title,
}: ArticleImageProps) => {
  const { env } = useAppContext();
  const { trackEvent } = useEventTracking();

  return (
    <a
      href={article_path(slug)}
      onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.ArticleImage }))}
      className={clsx(
        'relative block flex-shrink-0',
        {
          'max-sm:h-[calc(100vw*9/16)]': !isMobileFullWidth,
          '-mx-16 h-[calc(100vw*9/16)] sm:mx-0': isMobileFullWidth,
        },
        className
      )}
    >
      {isPro && <IconProTagThumbnail className="absolute right-0 top-0" />}
      <LazyImgixImage
        alt={title}
        className="article-image aspect-[16/9] h-auto w-full object-cover"
        src={getArticleImgSrc(id, picture, env)}
        sizes={sizes}
        wrapperClassName="!flex"
      />
    </a>
  );
};

export default ArticleImage;
